import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classnames from 'classnames';
import useDimensions from 'react-use-dimensions';
import { makeStyles } from '@material-ui/styles';
import { BsChevronDoubleRight } from 'react-icons/bs';

import Button from "components/shared/button";
import { childrenShape } from 'lib/shapes';

const HEIGHT = 76;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#D2CDC8',
  },
  secondaryButton: {
    width: 300,
  },
  chevrons: {
    verticalAlign: 'middle',
    marginBottom: 2,
    display: 'inline-block'
  },
  stickySection: {
    height: HEIGHT,
    zIndex: 99999,
    display: 'flex',
    backgroundColor: '#D2CDC8',
  },
  stickyWrapper: {
    backgroundColor: '#D2CDC8',
    alignSelf: 'center',
    display: 'flex',
    width: 1280,
    margin: '0 auto',
    '@media only screen and (min-width: 768px) and (max-width: 1280px)': {
      width: '95%'
    }
  },
  sticky: {
    bottom: 0,
    left: 0,
    position: 'fixed',
    right: 0,
  },
  left: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
  },
  middle: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  right: {
    flex: 1,
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
  },
}));

export const StickyFooter = props => {
  const {
    isBelowTop,
    middleSection,
    nextButton,
    nextButtonText,
    nextButtonOnClick,
    previousButtonOnClick,
    previousButtonText,
    showPreviousButton,
  } = props;
  const classes = useStyles();
  const [nextButtonPropOverrides, setNextButtonPropOverrides] = useState({});
  const [ref, { y }] = useDimensions();
  const isAboveFooter = window.innerHeight < HEIGHT + y;

  useEffect(() => {
    window.setNextButtonPropOverrides = setNextButtonPropOverrides;
    return () => {
      delete window.setNextButtonPropOverrides;
    };
  }, []);

  let nextButtonProps = { ...props.nextButtonProps, ...nextButtonPropOverrides };
  if (nextButtonOnClick) {
    if (typeof nextButtonOnClick === 'string') {
      nextButtonProps['onClick'] = () => eval(nextButtonOnClick);
    } else {
      nextButtonProps['onClick'] = nextButtonOnClick;
    }
  }

  let previousButtonProps = { ...props.previousButtonProps };
  if (previousButtonOnClick) {
    if (typeof previousButtonOnClick === 'string') {
      previousButtonProps['onClick'] = () => eval(previousButtonOnClick);
    } else {
      previousButtonProps['onClick'] = previousButtonOnClick;
    }
  }

  return (
    <div className={classes.root} ref={ref}>
      <div
        className={classnames({
          [classes.stickySection]: true,
          [classes.sticky]: isBelowTop && isAboveFooter,
        })}
      >
        <div className={classes.stickyWrapper}>
          <div className={classes.left}>
            {showPreviousButton && (
              <Button className={classes.secondaryButton} variant="secondary" {...previousButtonProps}>
                {previousButtonText}
              </Button>
            )}
          </div>

          <div className={classes.middle}>
            {middleSection && middleSection}
          </div>

          <div className={classes.right}>
            {nextButton ? nextButton : (
              <Button {...nextButtonProps}>
                <span>{nextButtonText}</span><BsChevronDoubleRight className={classes.chevrons} />
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

StickyFooter.propTypes = {
  isBelowTop: PropTypes.bool.isRequired,
  middleSection: PropTypes.node,
  nextButton: childrenShape,
  nextButtonText: PropTypes.string,
  nextButtonOnClick: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  previousButtonOnClick: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  nextButtonProps: PropTypes.shape({}),
  previousButtonProps: PropTypes.shape({}),
  previousButtonText: PropTypes.string,
  showPreviousButton: PropTypes.bool,
};

StickyFooter.defaultProps = {
  nextButtonOnClick: () => { },
  nextButtonProps: {},
  nextButtonText: 'Continue',
  previousButtonOnClick: () => { },
  previousButtonProps: {},
  previousButtonText: 'Previous Step',
  showPreviousButton: false,
};

export default StickyFooter;
